module.exports = __webpack_public_path__ + "img/edge_restauration_fast_food.f2aebce4.svg";